namespace advisorop.domains {

    // Mirrors McpClientProvider on the server.
    export enum McpClientProvider {
        CLAUDE = 1,
        CHATGPT = 2,
        GROK = 3,
        GEMINI = 4,
        CUSTOM = 99
    }

    // One AI connection (an OAuth client registration) on the AI Connections screen.
    export interface IMcpClient {
        id: number;
        name: string;
        provider: McpClientProvider;
        providerName: string;
        clientId: string;
        secretHint: string;
        redirectUris: string[];
        dateCreated: Date;
        secretCreatedOn?: Date;
        lastUsedOn?: Date;
        revoked: boolean;
        revokedOn?: Date;
        connectedUsers: number;
    }

    // Returned once, when a connection is created or its secret replaced.
    export interface IMcpClientSecret {
        client: IMcpClient;
        clientSecret: string;
    }

    export interface IMcpClientPreset {
        provider: McpClientProvider;
        displayName: string;
        redirectUris: string[];
        verified: boolean;
        setupHint: string;
    }

    export interface IMcpServerInfo {
        enabled: boolean;
        serverUrl: string;
        authorizationUrl: string;
        tokenUrl: string;
        scope: string;
        presets: IMcpClientPreset[];
    }
}
